import React from "react";

export default () => (
  <svg
    height="4rem"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    viewBox="0 0 3334 2775"
    width="4rem"
  >
    <g transform="matrix(4.16667,0,0,4.16667,0,0)">
      <g>
        <path
          d="M673.7,190.69L682.52,181.86C711.21,153.18 758.28,123.76 794.31,109.05C800.19,106.84 801.67,100.96 797.99,96.55C757.54,42.85 708.27,0.2 622.95,0.2C549.4,0.2 490.56,32.56 441.29,91.4L7.36,608.44C2.94,614.32 0,617.26 0,621.68C0,627.56 5.88,630.5 11.03,629.04L36.77,620.21C93.4,601.09 130.91,594.47 170.63,594.47C293.45,594.47 315.52,665.81 449.38,665.81C618.54,665.81 753.13,558.43 753.13,395.89C753.13,340.73 739.16,298.8 699.44,233.35L673.7,190.69ZM189.75,551.07C160.33,551.07 130.17,555.49 100.76,565.78L196.37,451.04C203.73,486.34 217.7,522.38 239.77,556.21C222.85,552.54 206.67,551.07 189.75,551.07ZM430.99,621.68C319.2,621.68 238.29,511.36 238.29,402.5L447.17,153.91C446.43,159.79 446.43,164.94 446.43,170.83C446.43,220.11 471.44,267.92 499.38,314.25L527.33,361.32C553.07,404.71 575.14,447.37 575.14,488.56C575.14,556.95 517.04,621.68 430.99,621.68ZM575.14,597.4C606.03,561.36 619.27,526.06 619.27,488.55C619.27,435.6 594.27,387.05 564.84,337.78L532.48,283.35C508.94,244.37 490.56,206.12 490.56,165.68C490.56,99.48 539.84,44.32 622.95,44.32C666.34,44.32 708.26,59.03 734.01,91.39C710.47,103.16 672.23,131.11 644.28,159.05L632.51,170.82C622.95,180.38 622.95,189.21 628.1,198.04L657.52,248.79C684,294.39 709,342.19 709,398.09C709,485.61 655.31,551.81 575.14,597.4Z"
          style={{
            fill: "rgb(7,57,55)",
            fillRule: "nonzero",
          }}
        />
      </g>
    </g>
  </svg>
);
